import { resolveIdentifier, types } from 'mobx-state-tree';

import PaymentMethod from './PaymentMethod';
import PaymentMethodGroup from './PaymentMethodGroup';
import PaymentProvider from './PaymentProvider';

const SelectedPayment = types.model('SelectedPayment', {
  group: types.maybeNull(types.reference(PaymentMethodGroup)),
  method: types.maybeNull(types.reference(PaymentMethod)),
  provider: types.maybeNull(types.reference(PaymentProvider)),
}).actions((self) => {
    return {
      updatePaymentMethodGroup({ id, groups }) {
        const group = resolveIdentifier(PaymentMethodGroup, groups, id);
        self.group = group;
        self.method = group.methods[0];
      },
      updatePaymentMethod({ id, methods }) {
        self.method = resolveIdentifier(PaymentMethod, methods, id);
      },
      updatePaymentProvider({ id, providers }) {
        self.provider = resolveIdentifier(PaymentProvider, providers, id);
      },
    };
  });

export default SelectedPayment;
